// function CalcButton(){
//     return (<>Hello,I am Button</>);
// }
import "../calculator.css"
const CalcButton = () => {
    const cal = ["C", "1", "2", "3", "+", "4", "5", "6", "-", "7", "8", "9", "%", "0", ".", "="]
    return (

        <div className="btn-list" >{cal.map(x => <button className="button">{x}</button>)}</div>)
}
export default CalcButton